import Spinner from '../designer/components/common/diagramConfigComponents/Spinner'
import ColorPicker from '../designer/components/common/diagramConfigComponents/ColorPicker'
import FontStyle from '../designer/components/common/diagramConfigComponents/FontStyle'
// import TextAlign from '../designer/components/common/diagramConfigComponents/TextAlign'
import Border from '../designer/components/common/diagramConfigComponents/Border'
import InputConfig from '../designer/components/common/diagramConfigComponents/InputConfig'
import SelectConfig from '../designer/components/common/diagramConfigComponents/SelectConfig'
import Radiobox from '../designer/components/common/diagramConfigComponents/Radiobox'
import {
  SIMPLE_TYPES,
  FILTER_TYPES,
  CAMPATIBLE_TITLE_CHART_TYPE,
  HAS_DATA_TABLE_CHART_TYPE
} from '@constants/dashboard'
import ChartDecoratorConfig from '@views/dataview-common/designer/common/ChartDecoratorConfig'

// 根据当前主题设置字体颜色
const getThemeTitleColor = () => {
  const backgroundTheme = ['colorful_white', 'gradual_blue']
  return backgroundTheme.indexOf(window.__DASHBOARD_THEME) !== -1 ? '#000' : '#FFF'
}

const CHART_REDIRECT_CONFIG = (isShowTitle, timePositionOptions) => ({
  title: '图表跳转',
  field: 'chartRedirect',
  spread: false,
  scope: 'container.redirect',
  invisible: (chart, screenMetadata) => {
    const { redirects } = (screenMetadata && screenMetadata.chart_relations) || {}
    if (!Array.isArray(redirects)) return false
    const redirectRelation = redirects.find(d => d.chart_id === (chart && chart.id))
    if (!redirectRelation) return false
    return Array.isArray(redirectRelation.complex_redirect) &&
      redirectRelation.complex_redirect.length > 0 &&
      redirectRelation.complex_redirect[0].target
  },
  items: [
    {
      field: 'redirectText',
      label: '跳转文本',
      scope: 'container.redirect.redirectText',
      component: {
        component: InputConfig,
        props: {
          type: 'input',
          placeholder: '',
          data: '查看详情'
        }
      },
      data: '查看详情'
    },
    {
      field: 'fontSize',
      // 作用域，用于组件标题的的样式配置（组件内部配置不需要设置作用域）
      scope: 'container.redirect.fontSize',
      label: '字号',
      component: {
        component: Spinner,
        props: {
          min: 6
        }
      },
      data: 14
    },
    {
      field: 'color',
      scope: 'container.redirect.color',
      label: '文本颜色',
      component: ColorPicker,
      data: '#C6C8D1',
    },
    {
      field: 'fontStyle',
      scope: 'container.redirect.fontStyle',
      label: '样式',
      component: FontStyle,
      data: {
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'underline'
      }
    },
    // {
    //   field: 'distance',
    //   scope: 'container.title.distance',
    //   label: '上下间距',
    //   component: {
    //     component: Spinner,
    //     props: {
    //       min: 0
    //     }
    //   },
    //   data: 10
    // },
    {
      field: 'textPosition',
      scope: 'container.redirect.textPosition',
      label: '显示位置',
      component: {
        component: SelectConfig,
        props: {
          options: timePositionOptions
        }
      },
      data: isShowTitle ? 'follow-title' : 'top-left'
    }
  ]
})

// 根据chartCode获取通用配置
const getCommonConfig = (chartCode, customConfig, name, penetrateName) => {
  name = penetrateName || name || ''
  // 通用标题配置
  const TITLE_CONFIG = {
    title: '标题',
    field: 'containerTitle',
    // 默认展开，显示当前Group下的所有配置项
    spread: false,
    // 默认启用当前Group配置，开关高亮显示
    // show: true,
    scope: 'container.title',
    items: [
      {
        field: 'text',
        label: '标题',
        scope: 'container.title.text',
        component: {
          component: InputConfig,
          props: {
            type: 'input',
            placeholder: '组件标题',
            data: name
          }
        },
        data: name || ''
      },
      {
        field: 'fontSize',
        // 作用域，用于组件标题的的样式配置（组件内部配置不需要设置作用域）
        scope: 'container.title.fontSize',
        label: '字号',
        component: {
          component: Spinner,
          props: {
            min: 6
          }
        },
        data: 16
      },
      {
        field: 'color',
        scope: 'container.title.color',
        label: '文本颜色',
        component: ColorPicker,
        data: getThemeTitleColor()
      },
      {
        field: 'fontStyle',
        scope: 'container.title.fontStyle',
        label: '样式',
        component: FontStyle,
        data: {
          fontWeight: 'normal',
          fontStyle: 'normal',
          textDecoration: 'normal'
        }
      },
      {
        field: 'distance',
        scope: 'container.title.distance',
        label: '上下间距',
        component: {
          component: Spinner,
          props: {
            min: 0
          }
        },
        data: 10
      },
      {
        field: 'textAlign',
        scope: 'container.title.textAlign',
        label: '显示位置',
        component: {
          component: SelectConfig,
          props: {
            options: [
              { value: 'center', text: '顶部居中' },
              { value: 'left', text: '顶部居左' },
              { value: 'right', text: '顶部居右' },
            ]
          }
        },
        data: 'left'
      },
      {
        field: 'hideTitle',
        scope: 'container.title.hideTitle',
        label: '隐藏标题',
        show: {
          field: 'show',
          data: (
            window.__currReportLayoutMode === 'free'
            || penetrateName
            || FILTER_TYPES.indexOf(chartCode) !== -1
            || CAMPATIBLE_TITLE_CHART_TYPE.indexOf(chartCode) !== -1)
        },
        items: []
      }
    ]
  }

  // 通用背景配置
  const BACKGROUND_CONFIG = {
    title: '背景',
    field: 'containerBackground',
    spread: false,
    show: window.__currReportLayoutMode === 'grid',
    scope: 'container.background',
    items: [
      {
        field: 'backgroundColor',
        scope: 'container.background.backgroundColor',
        label: '背景颜色',
        component: ColorPicker,
        data: ''
      }
    ]
  }

  // 通用边框配置
  const BORDER_CONFIG = {
    title: '边框',
    field: 'containerBorder',
    spread: false,
    show: false,
    scope: 'container.border',
    items: [
      {
        field: 'border',
        scope: 'container.border.borderStyle',
        label: '',
        component: Border,
        data: {
          borderColor: '',
          borderStyle: 'solid',
          borderWidth: 0
        }
      }
    ]
  }

  const timePositionOptions = [
    { value: 'top-left', text: '顶部居左' },
    { value: 'top-right', text: '顶部居右' },
    { value: 'bottom-left', text: '底部居左' },
    { value: 'bottom-right', text: '底部居右' }
  ]

  const isShowTitle = customConfig && !customConfig.find(config => config.field === 'containerTitle')
  const followWithTitle = isShowTitle && window.__currReportLayoutMode !== 'free'

  // 通用展示数据更新时间
  // const DATA_UPDATE_TIME_CONFIG = {
  //   title: '数据更新时间',
  //   field: 'containerUpdateTime',
  //   spread: false,
  //   show: false,
  //   scope: 'container.updateTime',
  //   items: [
  //     {
  //       field: 'timeType',
  //       scope: 'container.updateTime.timeType',
  //       label: '',
  //       items: [
  //         {
  //           field: 'icon',
  //           label: '时间展示方式',
  //           component: {
  //             component: Radiobox,
  //             props: {
  //               name: 'icon',
  //               radioName: ['显示图标', '显示时间'],
  //             }
  //           },
  //           data: true
  //         }
  //       ]
  //     },
  //     {
  //       field: 'timePosition',
  //       scope: 'container.updateTime.timePosition',
  //       label: '显示位置',
  //       component: {
  //         component: SelectConfig,
  //         props: {
  //           options: timePositionOptions
  //         }
  //       },
  //       data: isShowTitle ? 'follow-title' : 'top-left'
  //     }
  //   ]
  // }

  // 数据更新时间升级为单图备注
  const CHART_REMARK_CONFIG = {
    title: '图表备注',
    field: 'chartRemarkConfig',
    spread: false,
    scope: 'container.chartRemark',
    items: [
      {
        field: 'dataUpdate',
        scope: 'container.chartRemark.dataUpdate',
        label: '数据更新时间',
        show: {
          field: 'checked',
          data: false
        },
        items: [
          {
            field: 'dataTimeType',
            scope: 'container.chartRemark.dataUpdate.timeType',
            label: '时间展示方式',
            component: {
              component: Radiobox,
              props: {
                name: 'timeTypeIcon',
                radioName: ['显示图标', '显示时间'],
              },
              data: true
            },
          }
        ]
      }, {
        field: 'remarkDescription',
        scope: 'container.chartRemark.remarkDescription',
        label: '备注说明',
        items: [
          {
            field: 'title',
            label: '标题文本',
            component: {
              component: InputConfig,
              props: {
                placeholder: '请输入备注标题',
              }
            },
            data: ''
          }, {
            field: 'textAreaLabel',
            label: '内容文本',
            component: {
              component: InputConfig,
              props: {
                type: 'textarea',
                placeholder: '请输入备注内容',
              }
            },
            data: ''
          }, {
            field: 'position',
            label: '显示位置',
            component: {
              component: SelectConfig,
              props: {
                options: timePositionOptions
              }
            },
            data: followWithTitle ? 'follow-title' : 'top-left'
          }
        ]
      }
    ]
  }

  let commonConfig = []
  if (isShowTitle && !penetrateName) {
    commonConfig.push(TITLE_CONFIG)
    timePositionOptions.push({ value: 'follow-title', text: '跟随标题' })
  }

  commonConfig.push(CHART_REDIRECT_CONFIG(followWithTitle, [...timePositionOptions]))

  // 简单类型组件不新增数据更新时间
  if (customConfig && !customConfig.find(config => config.field === 'containerUpdateTime') && SIMPLE_TYPES.indexOf(chartCode) === -1 && chartCode !== 'select_filter') {
    // commonConfig.push(DATA_UPDATE_TIME_CONFIG)
    commonConfig.push(CHART_REMARK_CONFIG)
  }

  commonConfig = commonConfig.concat(BACKGROUND_CONFIG, BORDER_CONFIG)

  // 模拟运算表
  if (HAS_DATA_TABLE_CHART_TYPE.includes(chartCode)) {
    commonConfig.unshift(ChartDecoratorConfig())
  }
  return commonConfig
}

export {
  getCommonConfig
}
